import { DesignTokens } from "../../types"

export const createTextFontSizes: (
  foundation: DesignTokens.Foundation,
  contextual: DesignTokens.Contextual,
) => DesignTokens.TextFontSizes = (foundation, { fontSizes }) => ({
  small: fontSizes.small,
  medium: fontSizes.medium,
  large: fontSizes.large,
})

export const createTextLineHeights: (
  foundation: DesignTokens.Foundation,
  contextual: DesignTokens.Contextual,
) => DesignTokens.TextLineHeights = (foundation, { lineHeights }) => ({
  small: lineHeights.small,
  medium: lineHeights.medium,
  large: lineHeights.large,
})

export const createTextFontWeights: (
  foundation: DesignTokens.Foundation,
  contextual: DesignTokens.Contextual,
) => DesignTokens.TextFontWeights = (foundation, { fontWeights }) => ({
  default: fontWeights.regular,
  strong: fontWeights.semibold,
  heading: fontWeights.bold,
})
